const PlaceAirport = 1;
const AirportPlace = 2;
const PlacePlace = 3;

export const TripTypes = {PlaceAirport, AirportPlace, PlacePlace}
